import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';

import DeleteWarningIcon from '../../assets/Red_Dispute_Notification.png';

export const DeleteCoachingDialog = (props: any) => {
    const diaFooter = () => {
        return (
            <div className="text-center">
                <Button
                    className="btn-secondary me-3"
                    label="Cancel"
                    onClick={() => props?.setDiaDelete(false)}
                />

                <Button
                    className="btn-primary"
                    label="Delete"
                    onClick={props?.handleDelete}
                />
            </div>
        );
    };
    return (
        <Dialog
            visible={props?.diaDelete}
            style={{ width: '20vw', zIndex: '9999' }}
            onHide={() => props?.setDiaDelete(false)}
            footer={diaFooter}
        >
            <div className="text-center">
                <div>
                    <img src={DeleteWarningIcon} alt={DeleteWarningIcon} />
                </div>
                <p>Are you sure you want to delete this ITEM?</p>
            </div>
        </Dialog>
    );
};
